import { createTheme, type MantineColorsTuple } from "@mantine/core";

// Brand primary: #f05123 (orange-red). Generated a 10-shade tuple around it.
// Light shades for backgrounds, darker for hovers. Mantine uses index 6 as the
// default "filled" shade for the named primary color.
const brand: MantineColorsTuple = [
  "#fff1ed",
  "#ffe0d5",
  "#ffbfa9",
  "#ff9b78",
  "#fb7c50",
  "#f96637",
  "#f05123", // primary
  "#d8401a", // hover
  "#b8330f",
  "#902605",
];

// Brand secondary: black/near-black for surfaces. Used directly via inline
// styles where needed (e.g. console blocks). Mantine's dark palette already
// covers dark mode well.

export const theme = createTheme({
  primaryColor: "brand",
  defaultRadius: "md",
  colors: { brand },
  fontFamily:
    "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
  headings: { fontWeight: "600" },
});
